import { apiGet } from './client';

export type OverviewSummary = {
  /** 'merchant' = scoped to caller's merchant; 'platform' = platform-wide aggregate. */
  scope: 'merchant' | 'platform';
  visibility: {
    canSeeBalances: boolean;
    canSeeCounts: boolean;
  };
  balance: { pending: number; active: number } | null;
  todayTrxCount: number | null;
  totals: {
    deposit: { amount: number; count: number };
    disbursement: { amount: number; count: number };
  } | null;
};

export type ChartAmountByDayPoint = {
  /** YYYY-MM-DD in GMT+7. */
  date: string;
  depositAmount: number;
  depositCount: number;
  disbursementAmount: number;
  disbursementCount: number;
};

export type ChartCountByMethodSeries = {
  /** Method codes that appeared at least once in the window. */
  methods: string[];
  /** One row per day in the window; row[method] is the count for that day. */
  data: Array<Record<string, string | number>>;
};

export type OverviewCharts = {
  scope: 'merchant' | 'platform';
  range: { from: string; to: string };
  amountByDay: ChartAmountByDayPoint[];
  depositCountByMethod: ChartCountByMethodSeries;
  disbursementCountByMethod: ChartCountByMethodSeries;
};

export const overviewApi = {
  summary: () => apiGet<OverviewSummary>('/api/overview/summary'),
  charts: (params: { from?: string; to?: string } = {}) => {
    const q = new URLSearchParams();
    if (params.from) q.set('from', params.from);
    if (params.to) q.set('to', params.to);
    const qs = q.toString();
    return apiGet<OverviewCharts>(`/api/overview/charts${qs ? `?${qs}` : ''}`);
  },
};
